import { createId } from "@paralleldrive/cuid2";

import type {
  ModifierFormSchema,
  ModifierGroupSchema,
} from "../../../lib/validators/modifiers";

export type ModalType = "new" | "duplicate" | "existing";

export const defaultNewFormValues: ModifierFormSchema = {
  id: createId(),
  name: "",
  maximum: 25,
  minimum: 0,
  type: "modifier",
  parentModifierGroupId: null,
  sortOrder: 0,
  modifiers: [],
  subModifierGroups: [],
  modifiersList: [
    {
      itemId: createId(),
      name: "New modifier",
      sortOrder: 0,
      modifierType: "modifier",
      accordionOpen: true,
      data: {
        isOutOfStock: false,
        canBeMultiplied: false,
        additionalCost: "0.00",
      },
    },
  ],
};

export const modifierGroupDefaultValues: ModifierGroupSchema = {
  id: createId(),
  name: "",
  minimum: 0,
  maximum: 25,
  type: "modifier",
  parentModifierGroupId: null,
  sortOrder: 0,
  organizationId: "",
  modifiers: [],
  subModifierGroups: [],
};
